// Convert item price from integer to currency
export const formatPrice = (
  price,
  shouldDivide = true,
  tradeValue = false,
  hideTrailingZero = true
) => {
  const adjustedPrice =
    typeof trade_discount !== "undefined" && tradeValue
      ? price * ((100 - trade_discount) / 100)
      : price;

  const currency = document.body.dataset.currency;
  const _price = parseFloat(shouldDivide ? adjustedPrice / 100 : adjustedPrice);
  if (_price.toFixed(2).split(".")[1] == "00" && hideTrailingZero) {
    return `${currency}${_price}`;
  }

  return `${currency}${_price.toFixed(2)}`;
};

// In cases where we need to load something from Wishlist King on page load,
// this waits until the global variable is available before running a callback.
export const checkAppmate = (callback) => {
  if (!window.Cypress) {
    if (typeof Appmate !== "undefined") {
      const wishlistCollection = Appmate?.wk.collection?.items[0] || null;
      if (!wishlistCollection?.products) {
        setTimeout(() => checkAppmate(callback), 300);
      } else {
        const collection = Appmate.wk.collection;

        callback(collection);
      }
    } else {
      setTimeout(() => checkAppmate(callback), 300);
    }
  }
};

// Count is to limit the number of times we check for the widget, so it doesn't go on forever
var smileWidgetCount = 0;
var smileCloseButtonCount = 0;

export const checkSmileWidget = (callback) => {
  smileWidgetCount += 1;

  // Variables are initialised here so they are in scope of the subsequent if statements

  let smileUI = null;
  let smileLauncherContainer = null;
  let smileIframe = null;
  let smileButton = null;

  smileUI = document.querySelector("#smile-ui-container");

  // The following if statements check existence of each nested element within smileUI. If any of them are null,
  // we know the full widget hasn't loaded yet, so we recursively call this function again until it has loaded.

  if (smileUI) {
    smileUI.style.zIndex = 12;
    smileLauncherContainer = smileUI.querySelector(
      ".smile-launcher-frame-container"
    );
  }

  if (smileLauncherContainer) {
    smileIframe = smileLauncherContainer.querySelector("iframe");
  }

  if (smileIframe) {
    smileButton =
      smileIframe.contentWindow.document.querySelector(".launcher-button");
  }

  if (smileButton) {
    callback(smileUI, smileButton, smileLauncherContainer);
  } else if (smileWidgetCount < 10) {
    setTimeout(() => checkSmileWidget(callback), 300);
  }
};

// This performs the same function as checkSmileWidget, but for the close button on the widget.
// The close button is not rendered until the widget has been opened, so we need to wait for it to load.

export const checkSmileCloseButton = (callback) => {
  smileCloseButtonCount += 1;
  const smileUI = document.querySelector("#smile-ui-container");
  const smilePanelContainer = smileUI.querySelector(
    ".smile-panel-frame-container"
  );

  let smilePanelIframe = null;
  let smilePanelButton = null;

  if (smilePanelContainer) {
    smilePanelIframe = smilePanelContainer.querySelector("iframe");
  }

  if (smilePanelIframe) {
    smilePanelButton =
      smilePanelIframe.contentWindow.document.querySelector(".close-btn");
  }
  if (smilePanelButton) {
    callback(smileUI, smilePanelButton);
  } else if (smileCloseButtonCount < 10) {
    setTimeout(() => checkSmileCloseButton(callback), 300);
  }
};

// Handle truncation of text
export const truncate = ({ string, refId, length = 200 }) => {
  if (string.length > length) {
    return `
      <div class="truncate">
        <input type="checkbox" id="${refId}" class="hidden" />
        <p>
          <span>${string.substring(
            0,
            length
          )}</span><span class="truncate__ellipsis">...</span><span class="truncate__extra">${string.substring(
      length,
      string.length
    )}</span>
        </p><label for="${refId}">Read More</label>
      </div>
      `;
  }

  return string;
};

export const _debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const getSampleTotal = (currentSampleId) => {
  const samples = JSON.parse(document.body.dataset.samples);
  const restSamples = samples.filter((s) => s.id !== currentSampleId);

  return restSamples.map((s) => s.quantity).reduce((a, b) => a + b, 0);
};
